module.exports = __webpack_public_path__ + "04_mid_black.e020b7e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer5/04_mid_black.png
// module id = wNeZ
// module chunks = 0